import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import Collection from './Collection'
import ExpandableSection from './ExpandableSection'
import styles from './ExpandableKitItems.icss'

class ExpandableKitItems extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hideMoreButton: false }
	}

	render() {
		const { items, displayItems, showAllIfTooFewItems, renderAfterCollection, ...rest } = this.props
		const numItems = (items && items.length) || 0
		const hideMoreButton = showAllIfTooFewItems ? !(numItems > displayItems) || this.state.hideMoreButton : this.state.hideMoreButton
		return (
			<>
				{items && (
					<section className={styles.afterItem}>
						<ExpandableSection title={this.context.translate('{numItems|1 item|# items}', { numItems })} defaultExpanded>
							<Collection
								items={items.filter((item, index) => hideMoreButton || index < displayItems)}
								{...rest}
							/>
							{(hideMoreButton && renderAfterCollection) && renderAfterCollection}
							{!hideMoreButton && (
								<Button variant="text" onClick={() => this.setState({ hideMoreButton: true })} className={styles.moreButton}>
									{this.context.translate('More +')}
								</Button>
							)}
						</ExpandableSection>
					</section>
				)}
			</>
		)
	}
}

ExpandableKitItems.contextTypes = {
	translate: PropTypes.func
}

ExpandableKitItems.propTypes = {
	displayItems: PropTypes.number,
	showAllIfTooFewItems: PropTypes.bool,
	renderAfterCollection: PropTypes.node,
	items: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	className: PropTypes.string
}

ExpandableKitItems.defaultProps = {
	displayItems: 3,
	showAllIfTooFewItems: false,
	renderAfterCollection: undefined,
	items: undefined,
	className: undefined
}

export default ExpandableKitItems



// WEBPACK FOOTER //
// ./src/components/ExpandableKitItems.jsx